interface WebApp {
  initData: string;
  initDataUnsafe: { user?: { id: number; first_name?: string; username?: string } };
  ready: () => void;
  expand: () => void;
  colorScheme: "light" | "dark";
  /** Telegram client platform: "ios" | "android" | "tdesktop" | "macos" | "web" | "webk" … */
  platform?: string;
  /** Bot API 7.7+ — disables vertical swipe-to-close/minimize so the WebView's
   *  own scroll gesture wins. Absent on older clients (feature-detected). */
  disableVerticalSwipes?: () => void;
}

declare global {
  interface Window {
    Telegram?: { WebApp: WebApp };
  }
}

export function initTelegram(): WebApp | null {
  const wa = window.Telegram?.WebApp;
  if (!wa) return null;
  wa.ready();
  wa.expand();

  // iOS scroll fix (#958): on iOS the Mini App lives in a native draggable
  // BottomSheet. When the page scrolls via the document body (our model — every
  // route is `.tg-page{min-height:100vh}` with body scroll), iOS Telegram steals
  // the vertical drag for the sheet's minimize/close gesture, so the page can't
  // be scrolled and the bottom sections (e.g. home "为您精选") are unreachable.
  // `disableVerticalSwipes()` (Bot API 7.7+) hands the vertical gesture back to
  // page scrolling. The header-drag still closes the app, so this only removes
  // the conflicting body-swipe. No-op on older clients (method absent) and a
  // harmless tweak on android/desktop/web (they scroll regardless and don't use
  // the swipe-down-to-close affordance the same way) — so we only call it on
  // mobile platforms where the conflict actually exists.
  const platform = (wa.platform ?? "").toLowerCase();
  const isMobile = platform === "ios" || platform === "android";
  if (isMobile && typeof wa.disableVerticalSwipes === "function") {
    try {
      wa.disableVerticalSwipes();
    } catch {
      // Older client / unsupported — body scroll still works via the CSS hints
      // in main.css (-webkit-overflow-scrolling / overscroll-behavior).
    }
  }

  return wa;
}
